import { render, staticRenderFns } from "./SceneItem.vue?vue&type=template&id=2963322f&scoped=true&"
import script from "./SceneItem.vue?vue&type=script&lang=ts&"
export * from "./SceneItem.vue?vue&type=script&lang=ts&"
import style0 from "./SceneItem.vue?vue&type=style&index=0&id=2963322f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963322f",
  null
  
)

export default component.exports